import React from "react";
import { useAppSelector } from "src/redux/hooks";
import Layout from "src/components/layout/dashboard/Layout";
import PageHeader from "src/components/common/PageHeader";
import SuperAdminDashboard from "src/components/dashboard/SuperAdminDashboard";

const DashboardPage: React.FC = () => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authAdmin);

  return (
    <Layout
      type="admin"
      meta={{
        title: "Admin Dashboard | Invyntra",
        description: "",
        keywords: "sales, products, invoices, inventory, invyntra",
      }}
    >
      <div className="space-y-4">
        {/* Header */}
        <PageHeader
          title={`Welcome ${user?.firstName}!`}
          breadcrumbData={[
            { label: "Home", path: "/admin/dashboard" },
            { label: "Dashboard", path: "/admin/dashboard" },
          ]}
        />

        {/* Dashboard Content */}
        <SuperAdminDashboard />
      </div>
    </Layout>
  );
};

export default DashboardPage;
